import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AuthService } from '../core/auth/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { ProfileDialogComponent } from '../core/auth/profile/profile-dialog.component';
import { ChangePasswordDialogComponent } from '../core/auth/change-password-dialog/change-password-dialog.component';
import { Router } from "@angular/router";
import { TopBarService } from './top-bar.service';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
})
export class TopBarComponent implements OnInit {

  constructor(
    private _authService: AuthService,
    private _dialog: MatDialog,
    private _router: Router,
    private _topBarService: TopBarService
  ) { }

  public authenticated = this._authService._loggedIn$;
  public title = '';

  isLoginRoute(): boolean {
    return this._router.url === '/login';
  }

  ngOnInit() {
    this._topBarService.currentTitle.subscribe(title => {
      this.title = title;
    });
  }

  public get platformVersion() {
    return environment.appVersion;
  }

  public get userEmail() {
    return this._authService.loggedInUser?.email || "";
  }

  public get userLogin() {
    return this._authService.loggedInUser?.login || "";
  }

  public async logoutUser() {
    await this._authService.logout();
    this.navigateToLogin();
  }

  public async viewUserProfile() {
    this._dialog.open(ProfileDialogComponent, {
      width: '400px',
    })
  }

  public async userChangePassword() {
    this._dialog.open(ChangePasswordDialogComponent, {
      width: '400px',
    })
  }

  public navigateToDashboard() {
    this._router.navigate(['dashboard']);
  }

  public navigateToLogin() {
    this._router.navigate(['login']);
  }
}
